export const toPlainText = (value?: string | null) =>
  value
    ?.replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim() ?? ""
